import React, { useState } from 'react'

export const GlobalContext = React.createContext()

// component function
export function GlobalProvider(props) {
	const [globalState, setGlobalState] = useState({})
	return (
		<GlobalContext.Provider value={[globalState, setGlobalState]}>
			{props.children}
		</GlobalContext.Provider>
	)
}
